const STATIC_COPY = {
  HEADER: {
    PLANS_TITLE: 'Compare energy plans',
    REQUEST_FOR_CALLBACK: {
      TITLE: 'Need help?',
      LINK: 'Request a callback',
    },
  },
  FILTERS: {
    FUELS_TITLE: 'What are you looking for?',
    SOLAR_LABEL: 'Yes, I have solar panels',
    GAS_BOTTLES_LINK_TEXT: 'Looking for gas bottles?',
    POSTCODE_TITLE: 'Your postcode',
    USAGE: {
      CHOOSE_FROM_LIST_TITLE: 'Your daily usage',
      MANUAL_TITLE: 'Your energy usage',
      CTA_CHOOSE_FROM_LIST: 'Choose from our list',
      CTA_ENTER_MANUALLY: 'Enter usage manually',
    },
    GREEN_TITLE: 'Want to go green?',
  },
  RATES: {
    DESCRIPTION_RES: `The above figures are approximate charges based on a household of your size. To know the exact charges that may apply to you based on your distributor and meter type, please tell us your connection address.`,
    DESCRIPTION_BUS: `To know the exact charges that may apply to you based on your distributor and meter type, please tell us your connection address.`,
  },
};

export default STATIC_COPY;
